import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MailIcon from "@mui/icons-material/Mail";
import {
  Grid,
  Box,
  Divider,
  Menu,
  Typography,
  MenuItem,
  Popover,
  TextField,
  IconButton,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CommentIcon from "@mui/icons-material/Comment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
//import RandomlyColoredAvatar from "../../../../Layouts/Components/RandomlyColoredAvatar";
import CustomButton from "../../../shared/CustomButton";
import classes from "./SelectedMessageDetails.module.css";
// import SelectedMessagePrint from "./SelectedMessageExport";
import PDFHeader from "../../../shared/PDFHeader/PDFHeader";
import CustomizedTreeView, {
  CustomizedTreeViewPrint,
} from "./CustomizedTreeView";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  "&:before": {
    display: "none",
  },
  // width: "608px",
  padding: "5px 10px 5px 10px",
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowRightIcon sx={{ fontSize: "1.6rem" }} />}
    {...props}
  />
))(() => ({
  "&.Mui-expanded": {
    backgroundColor: "#F8FAFB",
    color: "#050D2E",
  },
  height: "36px",
  minHeight: "36px",
  // width: "608px",
  padding: "0px",
  borderRadius: "4px",
  flexDirection: "row-reverse",
  backgroundColor: "#F8FAFB",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
    color: "#050D2E",
    backgroundColor: "#F8FAFB",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
    color: "#050D2E",
    fontSize: ".875rem",
    fontWeight: "600",
  },
  "& .MuiAccordionSummary-content": {
    color: "#050D2E",
    fontSize: ".875rem",
    fontWeight: 550,
    lineheight: "16px",
    margin: "0px",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    color: "#050D2E",
    backgroundColor: "#F8FAFB",
    fontWeight: 550,
    lineheight: "16px",
    margin: "0px",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  // width: "608px",
  padding: "0px",
}));

const CustomTypography = styled(Typography)({
  fontSize: ".95rem",
  color: "#050D2E",
  fontWeight: 500,
  opacity: 2,
});

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
    sx={{ marginRight: "50px" }}
  />
))({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 210,
    color: "#050D2E",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      color: "#050D2E",
      fontSize: ".875rem",
      "&:active": {
        backgroundColor: "#D4EDF3",
      },
      "&:hover": {
        backgroundColor: "#D4EDF3",
      },
    },
  },
});

/**
 *
 * @param {Array} messageDetails Object of a selected message
 * @returns
 */
const SelectedMessageDetails = React.forwardRef(
  (
    { messageDetails, isPrinting, referenceNumber, messageTreeDetails },
    ref
  ) => {
    // const [expanded, setExpanded] = useState([messageDetails[0].title]);
    const [expanded, setExpanded] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menu, setMenu] = useState(null);
    const [detailMoreMenuOpen, setDetailMoreMenuOpen] = useState(false);
    const [detailCommentOpen, setDetailCommentOpen] = useState(false);
    const [comments, setComments] = useState({});
    const [currentTitle, setCurrentTitle] = useState(null);
    const [comment, setComment] = useState("");

    const { bankLogoURL } = useSelector((state) => state.swiftDay);

    //Accordion expand handler
    const handleChangeExpanded = (e, title) => {
      const index = expanded.findIndex((item) => item === title);

      if (index !== -1) {
        setExpanded(expanded.filter((item) => item !== title));
      } else {
        setExpanded([...expanded, title]);
      }
    };

    //detail menu
    const handleDetailMoreMenuClick = (event) => {
      setAnchorEl(event.currentTarget);
      setMenu(detailMoreMenu);
      setDetailMoreMenuOpen(true);
    };
    const handleCloseDetailMoreMenu = () => {
      setDetailMoreMenuOpen(false);
      setAnchorEl(null);
    };

    //comments handlers
    const handleDetailCommentClick = (event) => {
      setAnchorEl(event.currentTarget);
      setDetailCommentOpen(true);
      setCurrentTitle(event.currentTarget.id);
    };
    const handleCloseDetailComment = () => {
      setDetailCommentOpen(false);
      setAnchorEl(null);
      setCurrentTitle(null);
    };

    const handleAddComment = () => {
      const newComments = { ...comments };
      newComments[currentTitle] = comment;
      setComments(newComments);
      setComment("");
      handleCloseDetailComment();
    };

    const handleChangeComment = (e) => {
      setComment(e.target.value);
    };

    //detail menu items
    const detailMoreMenu = [
      {
        name: "Copy",
        action: (title) => {
          const row = messageDetails.find((detail) => detail.title === title);

          let text = "";

          row?.data.forEach(
            (detail) => (text = text + `${detail.key}: ${detail.value}\n`)
          );

          navigator.clipboard.writeText(text);
          handleCloseDetailMoreMenu();
        },
      },
      {
        name: "Copy Row Details",
        action: (title) => {
          const row = messageDetails?.find((detail) => detail.title === title);

          let text = `${row.fieldKey} ${row.title}\n`;

          row?.data.forEach(
            (detail) => (text = text + `${detail.key}: ${detail.value}\n`)
          );

          navigator.clipboard.writeText(text);
          handleCloseDetailMoreMenu();
        },
      },
      {
        name: "Copy All Rows",
        action: () => {
          let text = ``;

          messageDetails?.forEach((detail) => {
            text = text + `\n${detail.fieldKey} ${detail.title}\n`;
            detail.data.forEach(
              (row) => (text = text + `${row.key}: ${row.value}\n`)
            );
          });

          navigator.clipboard.writeText(text);
          handleCloseDetailMoreMenu();
        },
      },
    ];

    //clear comments on changing selected message
    useEffect(() => {
      setComments({});
    }, [messageDetails]);

    return (
      <Box sx={{ width: "99%", marginLeft: "1px" }} ref={ref}>
        {isPrinting ? (
          <div className={classes.messagePrintHeader}>
            <PDFHeader logoURL={bankLogoURL} />
            <Typography
              sx={{
                paddingBottom: "15px",
                fontSize: "1.5rem",
              }}
            >
              {referenceNumber}
            </Typography>
          </div>
        ) : null}
        {/* <PDFHeader /> */}

        {messageDetails?.map((detail) => {
          return (
            <div key={detail.title}>
              <Accordion
                expanded={isPrinting || expanded.includes(detail.title)}
                onChange={(e, expanded) => {
                  handleChangeExpanded(expanded, detail.title);
                }}
              >
                <AccordionSummary
                  aria-controls={`${detail.title}-content`}
                  id={`${detail.title}-header`}
                  sx={{
                    backgroundColor: expanded.includes(detail.title)
                      ? "#1492AF"
                      : "#ffffff",
                  }}
                  expandIcon={
                    <div
                      className={`${classes["hide-for-print"]} hide-in-export`}
                    >
                      <ArrowRightIcon sx={{ fontSize: "1.6rem" }} />
                    </div>
                  }
                >
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    {comments[detail.title] && (
                      <Grid
                        item
                        xs={12}
                        className={`${classes.comment} show-in-export`}
                      >
                        <Grid
                          container
                          justifyContent="flex-start"
                          alignItems="center"
                          sx={{
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#FFF0E4",
                            color: "#411C00",
                            fontSize: "14px",
                            px: 1,
                          }}
                        >
                          <Grid item>
                            <CommentIcon
                              sx={{ width: "14px", mr: "7px", mt: "8px" }}
                            />
                          </Grid>
                          <Grid item>{comments[detail.title]}</Grid>
                        </Grid>
                      </Grid>
                    )}

                    <Grid item sx={{ display: "flex" }} xs={10}>
                      <MailIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 550,
                          marginLeft: "10px",
                          width: "80%",
                        }}
                      >
                        {`${detail.fieldKey} ${detail.title}`}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={2}
                      className={`${classes["hide-for-print"]} hide-in-export`}
                    >
                      <IconButton
                        sx={{
                          background: "transperant",
                          borderRadius: "5px",
                          color: "#050D2E",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handleDetailCommentClick}
                        id={detail.title}
                      >
                        <CommentIcon
                          sx={{ fontSize: "1.3rem", color: "#50566E" }}
                          id={detail.title}
                        />
                      </IconButton>

                      <IconButton
                        sx={{
                          background: "transperant",
                          borderRadius: "5px",
                          color: "#050D2E",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handleDetailMoreMenuClick}
                        id={detail.title}
                      >
                        <MoreVertIcon
                          sx={{ fontSize: "1.3rem", color: "#50566E" }}
                          id={detail.title}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pt={2}>
                    <Grid item xs={1}></Grid>
                    <Grid item container rowGap={1} xs={11}>
                      <TableContainer sx={{ maxWidth: "100%" }}>
                        <Table sx={{ minWidth: "100%" }} size="small">
                          <TableBody>
                            {detail.data.map((row) => (
                              <TableRow
                                key={row.key}
                                sx={{
                                  "& td, & th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  <CustomTypography>
                                    {row.key}:
                                  </CustomTypography>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  sx={{ verticalAlign: "text-top" }}
                                >
                                  <CustomTypography
                                    sx={{
                                      maxWidth: "100%",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {row.value}
                                  </CustomTypography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {/*{detail.data.map((data) => (
                        <Grid item container columnGap={1} xs={12}>
                          <Grid item>
                            <CustomTypography>{data.key}:</CustomTypography>
                          </Grid>
                          <Grid item>
                            <CustomTypography
                              sx={{
                                maxWidth: "100%",
                                overflowWrap: "break-word",
                              }}
                            >
                              {data.value}
                            </CustomTypography>
                          </Grid>
                        </Grid>
                      ))}*/}
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Divider sx={{ marginTop: "15px", marginBottom: "15px" }} />
            </div>
          );
        })}

        {messageTreeDetails?.map((detail) => {
          return (
            <div key={detail.title}>
              <Accordion
                expanded={isPrinting || expanded.includes(detail.title)}
                onChange={(e, expanded) => {
                  handleChangeExpanded(expanded, detail.title);
                }}
              >
                <AccordionSummary
                  aria-controls={`${detail.title}-content`}
                  id={`${detail.title}-header`}
                  sx={{
                    backgroundColor: expanded.includes(detail.title)
                      ? "#1492AF"
                      : "#ffffff",
                  }}
                  expandIcon={
                    <div
                      className={`${classes["hide-for-print"]} hide-in-export`}
                    >
                      <ArrowRightIcon sx={{ fontSize: "1.6rem" }} />
                    </div>
                  }
                >
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    {comments[detail.title] && (
                      <Grid
                        item
                        xs={12}
                        className={`${classes.comment} show-in-export`}
                      >
                        <Grid
                          container
                          justifyContent="flex-start"
                          alignItems="center"
                          sx={{
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#FFF0E4",
                            color: "#411C00",
                            fontSize: "14px",
                            px: 1,
                          }}
                        >
                          <Grid item>
                            <CommentIcon
                              sx={{ width: "14px", mr: "7px", mt: "8px" }}
                            />
                          </Grid>
                          <Grid item>{comments[detail.title]}</Grid>
                        </Grid>
                      </Grid>
                    )}

                    <Grid item sx={{ display: "flex" }} xs={10}>
                      <MailIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 550,
                          marginLeft: "10px",
                          width: "80%",
                        }}
                      >
                        {detail.title}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={2}
                      className={`${classes["hide-for-print"]} hide-in-export`}
                    >
                      <IconButton
                        sx={{
                          background: "transperant",
                          borderRadius: "5px",
                          color: "#050D2E",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handleDetailCommentClick}
                        id={detail.title}
                      >
                        <CommentIcon
                          sx={{ fontSize: "1.3rem", color: "#50566E" }}
                          id={detail.title}
                        />
                      </IconButton>

                      <IconButton
                        sx={{
                          background: "transperant",
                          borderRadius: "5px",
                          color: "#050D2E",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handleDetailMoreMenuClick}
                        id={detail.title}
                      >
                        <MoreVertIcon
                          sx={{ fontSize: "1.3rem", color: "#50566E" }}
                          id={detail.title}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pt={2}>
                    <Grid item xs={1}></Grid>
                    <Grid item container rowGap={1} xs={11}>
                      {isPrinting ? (
                        <CustomizedTreeViewPrint
                          treeChildren={detail.children}
                        />
                      ) : (
                        <CustomizedTreeView treeChildren={detail.children} />
                      )}
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Divider sx={{ marginTop: "15px", marginBottom: "15px" }} />
            </div>
          );
        })}

        {/*comment popover */}
        <Popover
          open={detailCommentOpen}
          anchorEl={anchorEl}
          onClose={handleCloseDetailComment}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          elevation={2}
          sx={{
            marginRight: "50px",
            "& .MuiPopover-paper": {
              width: "320px",
              p: 2,
            },
            zIndex: 11000,
          }}
        >
          <Typography
            sx={{
              color: "#04162B",
              fontWeight: 550,
              fontSize: "1.125rem",
              mb: "10px",
            }}
          >
            Comment
          </Typography>
          {/*<Box sx={{ paddingBottom: "15px" }}>
                          <Grid
                            container
                            alignItems="center"
                            spacing={1}
                            sx={{ mb: "10px" }}
                          >
                            <Grid item>
                              <RandomlyColoredAvatar
                                name="Ahmed Hossam"
                                size={26}
                              />
                            </Grid>
                            <Grid item>
                              <Typography
                                sx={{
                                  color: "#04162B",
                                  fontWeight: 550,
                                  fontSize: ".875rem",
                                }}
                              >
                                Ahmed Hossam:
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#50566E",
                                  fontWeight: 550,
                                  fontSize: ".688rem",
                                }}
                              >
                                16 April, 2020 5:25 PM
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            sx={{
                              color: "#04162B",
                              fontSize: ".875rem",
                              marginLeft: "30px",
                            }}
                          >
                            Needs Revision
                          </Typography>
                        </Box>

                        <Box sx={{ paddingBottom: "15px" }}>
                          <Grid
                            container
                            alignItems="center"
                            spacing={1}
                            sx={{ mb: "10px" }}
                          >
                            <Grid item>
                              <RandomlyColoredAvatar
                                name="Alia Ghaly"
                                size={26}
                              />
                            </Grid>
                            <Grid item>
                              <Typography
                                sx={{
                                  color: "#04162B",
                                  fontWeight: 550,
                                  fontSize: ".875rem",
                                }}
                              >
                                Alia Ghaly:
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#50566E",
                                  fontWeight: 550,
                                  fontSize: ".688rem",
                                }}
                              >
                                16 April, 2020 4:45 PM
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            sx={{
                              color: "#04162B",
                              fontSize: ".875rem",
                              marginLeft: "30px",
                            }}
                          >
                            Done
                          </Typography>
                        </Box>*/}

          <Grid container alignItems="center" spacing={1} sx={{ mb: "10px" }}>
            {/*<Grid item>
                            <RandomlyColoredAvatar
                              name="Ahmed Hossam"
                              size={26}
                            />
                          </Grid>*/}
            <Grid item xs={12}>
              <TextField
                fullWidth
                sx={{
                  height: "36px",
                  "& .MuiInputBase-root": { height: "36px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                }}
                value={comment}
                onChange={handleChangeComment}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="end">
            <CustomButton
              type="dark"
              text="Add Comment"
              processing={false}
              disabled={false}
              action={handleAddComment}
            />
          </Grid>
        </Popover>

        {/*menu popover */}
        <StyledMenu
          id="menu"
          MenuListProps={{
            "aria-labelledby": "detail-menu",
          }}
          anchorEl={anchorEl}
          open={detailMoreMenuOpen}
          onClose={handleCloseDetailMoreMenu}
          sx={{ zIndex: 11000 }}
        >
          {menu?.map((item) => {
            return (
              <div key={item.id}>
                <MenuItem
                  disableRipple
                  onClick={() => item.action(anchorEl.id)}
                >
                  {item.name}
                </MenuItem>
              </div>
            );
          })}
        </StyledMenu>

        {/* <div id="messageToExport" style={{ display: "none" }}>
          <SelectedMessagePrint
            messageDetails={messageDetails}
            comments={comments}
          />
        </div> */}
      </Box>
    );
  }
);

export default SelectedMessageDetails;

// const messageDetails = [
//   {
//     name: "FIN Message MT",
//     name: "FIN",
//     icon: <MailIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />,
//   },
//   {
//     name: "1-1 Sender",
//     name: "sender",
//     icon: <AccountBalanceIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />,
//   },
//   {
//     name: "2-2 Receiver",
//     name: "reciever",
//     icon: <AccountBalanceIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />,
//   },
//   {
//     name: "GPI",
//     name: "gpi",
//     icon: <AccountBalanceIcon sx={{ fontSize: "1.3rem", color: "#50566E" }} />,
//   },
// ];
